import { News } from '@/@types/index'
import Link from 'next/link'
import { ROUTES } from '@/config/routes'
import { FallbackImage } from '../common'
import IconSprite from "../common/IconSprite";

type NewCardProps = {
  newItem: News
}

export const NewCard = ({ newItem }: NewCardProps) => {
  const { image, date, title, slug, categorySlug } = newItem

  const formatDate = (dateString: string) => {
    const options: Intl.DateTimeFormatOptions = {
      day: '2-digit',
      month: 'long',
      year: 'numeric',
    }
    return new Intl.DateTimeFormat('es-ES', options).format(new Date(dateString))
  }

  return (
    <Link
      href={ROUTES.news.details(categorySlug, slug)}
      className="max-w-sm h-full bg-white text-black shadow-lg p-4 flex flex-col justify-between space-y-4">
      {/* Imagen */}
      <FallbackImage
        className="aspect-video rounded-sm w-full h-full object-cover"
        src={image}
        alt={title}
        width={550}
        height={275}
      />
      {/* Contenido */}
      <div className="space-y-2">
        <h5 className="text-gray-500 uppercase">{formatDate(date)}</h5>
        <p className="font-bold line-clamp-2 min-h-[3rem] uppercase">{title}</p>
      </div>
      {/* Botón Ver Más */}
      <div
        className="w-[100px] inline-flex items-center px-3 py-1 text-sm font-medium bg-silver rounded-sm hover:bg-yellow transition-colors gap-2"
      >
        VER MÁS
        <IconSprite id="ic_full_arrow_right" className="w-4 h-4" />
      </div>
    </Link>
  );
};
